import { render, staticRenderFns } from "./editor_layout.vue?vue&type=template&id=e5f36904&scoped=true&"
import script from "./editor_layout.vue?vue&type=script&lang=js&"
export * from "./editor_layout.vue?vue&type=script&lang=js&"
import style0 from "./editor_layout.vue?vue&type=style&index=0&id=e5f36904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f36904",
  null
  
)

export default component.exports